"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcMenuElementCreator = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var common_constants_1 = require("../../../common/constants/common-constants");
var menu_constants_1 = require("./menu-constants");
var BcMenuElementCreator = (function (_super) {
    __extends(BcMenuElementCreator, _super);
    function BcMenuElementCreator() {
        var _this = _super.call(this) || this;
        _this.showProfileInSubmenu = false;
        return _this;
    }
    BcMenuElementCreator.prototype.createHTMLElement = function (conf) {
        var element = document.createElement(conf.tag);
        conf.classList &&
            conf.classList.forEach(function (c) {
                element.classList.add(c);
            });
        conf.attributes &&
            conf.attributes.forEach(function (attr) {
                element.setAttribute(attr.name, attr.value);
            });
        return element;
    };
    BcMenuElementCreator.prototype.createLogoutBtn = function () {
        var _this = this;
        var logoutBtn = document.createElement(common_constants_1.BcCommonConstants.BUTTON_TAG);
        if (window.innerWidth >= menu_constants_1.BC_LG) {
            logoutBtn.classList.add(common_constants_1.BcCommonConstants.BUTTON_FAB_CLASS);
            logoutBtn.classList.add(common_constants_1.BcCommonConstants.BUTTON_FAB_MINI_CLASS);
            logoutBtn.innerHTML = "<bc-icon class=\"bc-icon bc-sm\">quit</bc-icon>";
        }
        else {
            logoutBtn.classList.add(common_constants_1.BcCommonConstants.BC_BTN_CLASS);
            logoutBtn.classList.add(common_constants_1.BcCommonConstants.BTN_SECONDARY_CLASS);
            logoutBtn.classList.add(common_constants_1.BcCommonConstants.BUTTON_SMALL_CLASS);
            logoutBtn.innerHTML = "<bc-icon class=\"bc-icon bc-sm\">quit</bc-icon> CERRAR SESI\u00D3N";
        }
        if (this.logoutFunction) {
            logoutBtn.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
                _this.logoutFunction();
            });
        }
        return logoutBtn;
    };
    BcMenuElementCreator.prototype.createProfileSection = function () {
        var container = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        container.classList.add('bc-submenu-profile-container');
        container.innerHTML = "<div class=\"bc-submenu-profile-icon\">\n              <em class=\"bc-icon\">user</em>\n          </div>\n          <div class=\"bc-submenu-profile\">\n            <span>".concat(this.profileData.user, "</span>\n            <a href=\"").concat(this.profileData.updateUserDataUrl, "\">Actualizar mis datos</a>\n          </div>");
        if (!this.profileData.updateUserDataUrl) {
            container.querySelector('a').style.display = 'none';
        }
        return container;
    };
    BcMenuElementCreator.prototype.createExtraElements = function () {
        this.submenu = this.createHTMLElement({
            tag: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [menu_constants_1.BC_MENU_SUBMENU],
        });
        this.itemElement = this.createHTMLElement({
            tag: 'a',
            classList: [menu_constants_1.BC_MENU_ITEM_OPTIONS],
        });
        var liElement = this.createHTMLElement({ tag: common_constants_1.BcCommonConstants.LI_TAG });
        var icon = 'bc-icon';
        var iconElement = this.createHTMLElement({
            tag: common_constants_1.BcCommonConstants.EM_TAG,
            classList: [icon],
        });
        iconElement.innerText = 'menu';
        var textElement = this.createHTMLElement({ tag: common_constants_1.BcCommonConstants.DIV_TAG });
        textElement.innerText = 'Más';
        liElement.appendChild(iconElement);
        liElement.appendChild(textElement);
        this.itemElement.appendChild(liElement);
        var headerTitle = this.createHTMLElement({
            tag: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: ['bc-submenu-title'],
        });
        var title = this.createHTMLElement({ tag: 'h3' });
        title.innerText = 'Más';
        headerTitle.appendChild(title);
        this.closeBtn = this.createHTMLElement({
            tag: common_constants_1.BcCommonConstants.ICONS_CLASS,
            classList: [common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_SM_CLASS],
        });
        this.closeBtn.innerHTML = 'error';
        headerTitle.appendChild(this.closeBtn);
        this.submenu.appendChild(headerTitle);
        this.logoutBtnContainer = this.createHTMLElement({
            tag: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [menu_constants_1.BC_MENU_SUBMENU_FOOTER_CONTAINER],
        });
        this.logoutBtnContainer.appendChild(this.createLogoutBtn());
        this.submenuContentContainer = this.createHTMLElement({
            tag: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: ['bc-submenu-container'],
        });
        this.submenuListContainer = this.createHTMLElement({ tag: common_constants_1.BcCommonConstants.DIV_TAG });
        if (this.profileData && this.profileData.user !== '') {
            this.submenuContentContainer.appendChild(this.createProfileSection());
        }
        this.submenuListContainer['style'].overflow = common_constants_1.BcCommonConstants.HIDDEN;
        this.submenuContentContainer.appendChild(this.submenuListContainer);
    };
    return BcMenuElementCreator;
}(default_behavior_1.BcDefaultBehavior));
exports.BcMenuElementCreator = BcMenuElementCreator;
